import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { SHOW_MODAL_QUERY_PARAM, MODAL_IDENTIFIER_QUERY_PARAM, CONDUCTOR_MODAL_QUERY_PARAM } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { getCurrentPath } from "@faire/web--source/common/Path";
export function extractLinkFromActions(actions) {
    var _actions_find_navigate, _actions_find, _actions_find_navigate1, _actions_find1, _queryParamAction_open_modal_open_conductor_modal, _queryParamAction_open_modal;
    var newTabLink = (_actions_find = actions.find(function(action) {
        return action.navigate;
    })) === null || _actions_find === void 0 ? void 0 : (_actions_find_navigate = _actions_find.navigate) === null || _actions_find_navigate === void 0 ? void 0 : _actions_find_navigate.new_tab_link;
    var nonNavigationActions = actions.filter(function(action) {
        var _action_open_modal;
        return !action.navigate && !((_action_open_modal = action.open_modal) === null || _action_open_modal === void 0 ? void 0 : _action_open_modal.open_conductor_modal);
    });
    var link = (_actions_find1 = actions.find(function(action) {
        return action.navigate;
    })) === null || _actions_find1 === void 0 ? void 0 : (_actions_find_navigate1 = _actions_find1.navigate) === null || _actions_find_navigate1 === void 0 ? void 0 : _actions_find_navigate1.link;
    // the sdui_modal is driven from the query param, so we need to append the query param to the link
    var queryParamAction = actions.find(function(action) {
        var _action_open_modal;
        return (_action_open_modal = action.open_modal) === null || _action_open_modal === void 0 ? void 0 : _action_open_modal.open_conductor_modal;
    });
    var queryModalIdentifier = queryParamAction === null || queryParamAction === void 0 ? void 0 : (_queryParamAction_open_modal = queryParamAction.open_modal) === null || _queryParamAction_open_modal === void 0 ? void 0 : (_queryParamAction_open_modal_open_conductor_modal = _queryParamAction_open_modal.open_conductor_modal) === null || _queryParamAction_open_modal_open_conductor_modal === void 0 ? void 0 : _queryParamAction_open_modal_open_conductor_modal.conductor_token;
    if (queryModalIdentifier) {
        var _obj;
        link = getCurrentPath().append((_obj = {}, _define_property(_obj, SHOW_MODAL_QUERY_PARAM, CONDUCTOR_MODAL_QUERY_PARAM), _define_property(_obj, MODAL_IDENTIFIER_QUERY_PARAM, queryModalIdentifier), _obj)).toString();
    }
    return {
        link: link,
        newTabLink: newTabLink,
        nonNavigationActions: nonNavigationActions
    };
}
